import { render, staticRenderFns } from "./ChooseStartClaim.vue?vue&type=template&id=6b04d585&"
import script from "./ChooseStartClaim.vue?vue&type=script&lang=js&"
export * from "./ChooseStartClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports